import { render, staticRenderFns } from "./ArchiveSearch.vue?vue&type=template&id=61b5100a&scoped=true&"
import script from "./ArchiveSearch.vue?vue&type=script&lang=js&"
export * from "./ArchiveSearch.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveSearch.vue?vue&type=style&index=0&id=61b5100a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b5100a",
  null
  
)

export default component.exports